import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/metaPixel';

/**
 * Component that tracks page views with Meta Pixel when routes change
 * This should be included once in your app, typically near the top level
 */
const MetaPixelPageTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view whenever the location changes
    trackPageView();
    
    // Log for debugging
    if (process.env.NODE_ENV === 'development') {
      console.log('📊 Meta Pixel: Page view tracked for', location.pathname);
    }
  }, [location]);
  
  // This component doesn't render anything
  return null;
};

export default MetaPixelPageTracker;
